import {FotoModel} from './foto.model';
import {ConyugeModel} from './conyuge.model';
import {DomicilioModel} from './domicilio.model';
import {InformacionEconomicaModel} from './informacion-economica.model';
import {ReferenciaPersonalModel} from './referencia-personal.model';
import {ReferenciaBancariaModel} from './referencia-bancaria.model';
import {ResidenciaFiscalExtranjeroModel} from './residencia-fiscal-extranjero.model';
import {EntregaTarjetaModel} from './entrega-tarjeta.model';
import { DatosAhorroProgramadoModel } from './datosAhorroProgramado.model';
import { DatosOroavisosModel } from './datosOroavisos.model';


export class DatosAspiranteModel {
  [x: string]: any;
  Cedula!: string;
  CodigoDactilar!: string;
  SelfieVida?: boolean;
  Fotos: FotoModel[] = [];
  NombresCompletos?: string;
  Nombres: string='';
  Apellidos?: string;
  FechaNacimiento?: Date;
  CodPaisNacionalidad?: string;
  EstadoCivil?: string;
  Conyuge!: ConyugeModel;
  Celular?: string;
  CorreoElectronico?: string;
  Domicilio!: DomicilioModel;
  EntregaTarjeta?: EntregaTarjetaModel;
  InformacionEconomica: InformacionEconomicaModel = new InformacionEconomicaModel;
  ReferenciasPersonales: ReferenciaPersonalModel[] = [];
  TieneCuentasSistemaFinancieroNacional?: boolean;
  TieneCuentasSistFinanNacional?: boolean;
  ReferenciasBancarias: ReferenciaBancariaModel[] = [];
  TieneResidFiscalExtranjero!: boolean;
  ResidFiscalExtranjero: ResidenciaFiscalExtranjeroModel = new ResidenciaFiscalExtranjeroModel;
  NombreEmpresa?: string;
  Antiguedad?: string;
  LugarNacimiento!: string;
  CodigoOficinaOficialCredito?: string;
  NombreOficinaOficialCredito?: string;
  AceptaAhorroProgramado: boolean = false;
  AceptaOroavisos: boolean = false;
  DatosAhorroProgramado?: DatosAhorroProgramadoModel;
  DatosOroavisos?: DatosOroavisosModel;
  CorreoEnmascarado?: string;
  CelularEnmascarado?: string;
  GeneraFormularioResid!: boolean;

  clear() {
    this.Cedula = '';
    this.CodigoDactilar = '';
    this.SelfieVida = false;
    this.Fotos = [];
    this.NombresCompletos = '';
    this.Nombres = '';
    this.Apellidos = '';
    this.FechaNacimiento = new Date();
    this.CodPaisNacionalidad = '';
    this.EstadoCivil = '';
    this.Conyuge = new ConyugeModel();
    this.Celular = '';
    this.CorreoElectronico = '';
    this.Domicilio = new DomicilioModel();
    this.InformacionEconomica = new InformacionEconomicaModel();
    this.ReferenciasPersonales = [];
    this.TieneCuentasSistemaFinancieroNacional = false;
    this.ReferenciasBancarias = [];
    this.TieneResidFiscalExtranjero = false;
    this.ResidFiscalExtranjero = new ResidenciaFiscalExtranjeroModel();
    this.NombreEmpresa = '';
    this.Antiguedad = '';
    this.LugarNacimiento = '';
    this.CodigoOficinaOficialCredito = '';
    this.NombreOficinaOficialCredito = '';
    this.AceptaAhorroProgramado = false;
    this.AceptaOroavisos = false;
    this.DatosAhorroProgramado = new DatosAhorroProgramadoModel();
    this.DatosOroavisos = new DatosOroavisosModel();
    this.CorreoEnmascarado = '';
    this.CelularEnmascarado = '';
    this.GeneraFormularioResid = false;
  }
}
